import React from 'react';
import { getStyle, StylePropType, toast } from '../../components';
import './EmptyView.less';
import { IndexItem } from '..';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import autobind from 'autobind-decorator';
import { formatDate } from '../../utils';

type EmptyViewIconType = 'lovely' | 'hard' | 'happy' | 'none' | 'kong' | 'empty' | 'classify';

interface EmptyViewPropType extends StylePropType {
    prefixCls?: string;
    text?: string;
    icon?: EmptyViewIconType;
    btn_text?: string;
    onClick?: any;
    ordermsg?: any;
}

const ICON_MAP = {
    'kong': require('../../images/shop_empty_new.png'),
    'empty': require('../../images/order_empty.png'),
    'classify': require('../../images/classification.png')
};

class EmptyView extends React.Component<EmptyViewPropType> {
    static defaultProps = {
        prefixCls: 'empty-view',
        icon: 'none'
    };

    @autobind
    onCopy() {
        toast('复制成功');
    }

    render() {
        const {prefixCls, icon, text, btn_text, ordermsg, onClick} = this.props;
        let style = getStyle(this.props);
        return <div style={style} className={ordermsg ? `${prefixCls} ordermsg` : prefixCls}>
            {icon != 'none' && <img style={{width: '17.5rem'}} src={ICON_MAP[icon!]}/>}
            {ordermsg && ordermsg.orderStatus != 5 && ordermsg.orderItems.map((item, index) => {
                return <IndexItem data={item} key={index}/>;
            })}
            <div className={`${prefixCls}` + 'text'}>
                {text && text!.split('\n').map((str, key) => {
                    return <div key={key} className={`test${key}`}>{str}</div>;
                })}
                {ordermsg && ordermsg.orderStatus != 5 ?
                    <div className={`${prefixCls}` + 'order'}>
                        <p>发货时间:<span>{ordermsg.consignTime && formatDate(ordermsg.consignTime)}</span></p>
                        <p>快递方式:<span>{ordermsg.expressCompanyName}</span></p>
                        <p>快递单号:<span>{ordermsg.wayBillId}</span>
                            <CopyToClipboard text={ordermsg.wayBillId}>
                                <span className={prefixCls + 'copy'} onClick={this.onCopy}>复制</span>
                            </CopyToClipboard>
                        </p>
                    </div>
                    :
                    ordermsg && <div className={`${prefixCls}` + 'order'}>
                        <p>订单号:<span>{ordermsg && ordermsg.orderId}</span>
                            <CopyToClipboard text={ordermsg && ordermsg.orderId}>
                                <span className={prefixCls + 'copy'} onClick={this.onCopy}>复制</span>
                            </CopyToClipboard>
                        </p>
                    </div>}
            </div>
            {btn_text && <div className={`${prefixCls}` + 'btn'} onClick={() => {
                onClick();
            }}>{btn_text}</div>}
        </div>;
    }
}

export default EmptyView;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/empty/EmptyView.tsx